import React from 'react';

const cor = '#B51013';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Arial, sans-serif', background: '#f5f5f5', padding: '24px',
      }}>
        <div style={{
          background: '#fff', borderRadius: '12px', padding: '40px',
          maxWidth: '480px', width: '100%', textAlign: 'center',
          border: '1px solid #e5e5e5', boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
        }}>
          <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: '#FCEBEB', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
              <circle cx="13" cy="13" r="11" stroke={cor} strokeWidth="1.5"/>
              <path d="M13 8v5" stroke={cor} strokeWidth="2" strokeLinecap="round"/>
              <circle cx="13" cy="17" r="1.2" fill={cor}/>
            </svg>
          </div>
          <div style={{ fontSize: '16px', fontWeight: '700', color: '#1a1a1a', marginBottom: '8px' }}>
            Algo deu errado
          </div>
          <div style={{ fontSize: '13px', color: '#888', marginBottom: '24px', lineHeight: '1.5' }}>
            Ocorreu um erro inesperado. Tente recarregar a página.<br/>
            Se o problema persistir, entre em contato com o suporte.
          </div>
          {this.state.error && (
            <details style={{ textAlign: 'left', marginBottom: '20px' }}>
              <summary style={{ fontSize: '11px', color: '#aaa', cursor: 'pointer', marginBottom: '6px' }}>Detalhes técnicos</summary>
              <pre style={{ fontSize: '10px', color: '#888', background: '#f5f5f5', padding: '10px', borderRadius: '6px', overflow: 'auto', whiteSpace: 'pre-wrap' }}>
                {this.state.error.toString()}
              </pre>
            </details>
          )}
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              style={{ padding: '9px 20px', background: 'none', border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', color: '#666', cursor: 'pointer' }}
            >
              Tentar novamente
            </button>
            <button
              onClick={() => window.location.href = '/'}
              style={{ padding: '9px 20px', background: cor, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
            >
              Ir para o início
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
